module.exports = __webpack_public_path__ + "static/404@2x-210931e5b4eb3d2218cd614ecf2e6adf.png";